import { get } from "lodash";

export const getTemplate = state => get(state, "programa.template", {});
export const getIsLogged = state => get(state, "programa.isLogged", {});
export const isAllowedToNavigate = state =>
  get(state, "programa.isAllowedToNavigate", true);
export const getChatOnline = state => get(state, "programa.chatOnline", "");
